import {
  CONTROLS,
  boundFieldName,
  controlOf,
  isBoundField,
  isRequiredBoundField,
  type BoundField,
  type ModuleDefinitionField,
  type ModuleField,
} from "shared"

/**
 * What a field is called, on the form and on the canvas. Every field is born named for its
 * control, so this is its label; "Unnamed field" is the one state the schema
 * refuses, shown so a cleared name still has something to click on. A bound
 * field is called what it is bound to until the administrator renames it.
 */
export const fieldName = (field: ModuleDefinitionField): string =>
  isBoundField(field)
    ? boundFieldName(field)
    : field.label.trim() || "Unnamed field"

/**
 * The field a bound field is drawn as: its binding's control, called what the
 * bound field is called, and Required where its binding or the form admin
 * makes it so.
 */
export const drawnAs = (field: BoundField): ModuleField => ({
  ...CONTROLS[controlOf(field)].create(field.id),
  label: boundFieldName(field),
  required: isRequiredBoundField(field),
})

/** How to answer a field, or nothing when it has no instructions to give. */
export const fieldInstructions = (field: ModuleField): string | undefined =>
  field.instructions?.trim() || undefined
